import React from 'react';
import { useWishListData } from 'hooks';

export default Component => props => (
    <Component {...props} wishlist={useWishListData()} />
);
